exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control-overide{display:-webkit-box;display:-ms-flexbox;display:flex;height:auto!important}.date-input-i{font-size:10px}", ""]);

// exports
